export default [
    {
        path: '/website-blogs',
        props: true,
        component: () => import('@/views/WebsiteBlog'),
    },
];
